import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import NowUiKit from './plugins/now-ui-kit';
import API from './service/api';
import Vuex from 'vuex';
import User from './service/user';
import Search from './module/search/search.service.js';
import VueSocialSharing from 'vue-social-sharing';
import Croppa from 'vue-croppa';
import i18n from './i18n/i18n';
import group from './store/modules/group';
import article from './store/modules/article'

let user = new User();
router.beforeEach((to,from,next)=>{
  if(to.path == '/' ){
    if(user.check_is_wxc_domain()){
      next('/group');
    }else{
      next('/group');
    }
  }else{
    next();
  }
})


Vue.use(Croppa);
Vue.config.productionTip = false;

Vue.prototype.$api = new API();

Vue.use(NowUiKit);
Vue.use(Vuex);

Vue.use(VueSocialSharing);

const store = new Vuex.Store({
  modules: {
    group,
    article
  },
  state: {
    user:new User(),
    search:new Search(),
  },
  mutations: {
    setUserinfoGroupblogs(state,params){
      state.user.groupBlogger = params;
    },
    setGroupBlogEditer(state,params){
      state.user.groupBlogEditer = params;
    },
    setUserinfo(state,params){
      state.user.userinfo = params;
    },
    setUserinfo(state,params){
      state.user.userinfo = params;
    },
  },
  
})

new Vue({
  
  store: store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
